/**
 * The two paths that arrive from an email rather than from a link inside the application.
 *
 * They must match `AccountService.VerifyEmailPath` and `AccountService.ResetPasswordPath` on the
 * server, which is where the links are composed. The failure when they drift is silent: React
 * Router sends an unknown path to the sign-in page, so the person who asked to reset a password
 * is shown a sign-in form and nothing anywhere records that anything went wrong.
 */
export const emailPaths = {
  verifyEmail: '/verify-email',
  resetPassword: '/reset-password',
} as const
